import { create } from "zustand";

/** Deliberately not persisted: a stale selection would silently reroute the mic after refresh. */
interface LabRoomState {
  room: { id: string; name: string } | null;
  setRoom: (room: { id: string; name: string } | null) => void;
}

export const useLabRoomStore = create<LabRoomState>((set) => ({
  room: null,
  setRoom: (room) => set({ room }),
}));
